import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { Tooltip, IconButton, Box } from "@material-ui/core";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";

import { columnTextField } from "utils/tables-utils";

import VisibilityIcon from "@mui/icons-material/Visibility";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

export default function TableVitrines({
  data,
  loading,
  loadingDetails,
  totalSize,
  currentPage,
  currentSizePerPage,
  onTableChange,
  onPageChange,
  handleViewDetails,
}) {
  const history = useHistory();

  const columnModel = [
    columnTextField({
      dataField: "IdVitrineVirtualB2b",
      text: "Cód. Vitrine",
      align: "center",
    }),
    columnTextField({
      dataField: "Descricao",
      text: "Vitrine",
      align: "left",
      style: {
        maxWidth: "20vw",
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
      formatter: (_, row) => (row.Descricao !== "" ? row.Descricao : row.Nome),
    }),
    columnTextField({
      dataField: "Status",
      text: "Status",
      align: "center",
      formatter: (_, row) =>
        row.Status.charAt(0).toUpperCase() + row.Status.slice(1).toLowerCase(),
    }),
    columnTextField({
      dataField: "NomeUsuario",
      text: "Criada Por",
      align: "center",
    }),
    columnTextField({
      dataField: "DataInclusaoFormat",
      text: "Data Criação",
      align: "center",
    }),
    columnTextField({
      dataField: "NomeUsuarioPublicacao",
      text: "Publicada Por",
      align: "center",
    }),
    columnTextField({
      dataField: "DataPublicacaoFormat",
      text: "Data Publicação",
      align: "center",
    }),
    columnTextField({
      dataField: "DataVigenciaInicioFormat",
      text: "Vigência",
      align: "center",
      formatter: (_, row) => (
        <>
          {row?.DataVigenciaInicioFormat} - {row?.DataVigenciaFimFormat}
        </>
      ),
    }),
    {
      dataField: "selected",
      text: "",
      align: "center",
      headerAlign: "center",
      formatter: (_, row) => (
        <Box display="flex" justifyContent="space-between" width="75px">
          <Tooltip title="Visualizar Vitrine">
            <IconButton
              size="small"
              aria-label="details"
              onClick={() => handleViewDetails(row.IdVitrineVirtualB2b)}
              disabled={loadingDetails}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          {row.Status === "CADASTRADO" ? (
            <Tooltip title="Publicar Vitrine">
              <IconButton
                size="small"
                aria-label="details"
                onClick={() => {
                  history.push(
                    `/admin/publicar-vitrine-b2b?id=${row.IdVitrineVirtualB2b}`,
                  );
                }}
              >
                <Inventory2OutlinedIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <div />
          )}
        </Box>
      ),
    },
  ];

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      onPageChange(page, sizePerPage);
    },
    [onPageChange],
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      onPageChange(page, sizePerPage);
    },
    [onPageChange],
  );

  return (
    <div>
      {loading ? (
        <LoadingData searching={true} label="Buscando dados..." />
      ) : (
        <ToolkitTable
          keyField="IdVitrine"
          dataTable={data}
          columnModel={columnModel}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          bootstrapTableProps={{
            remote: true,
            onTableChange: onTableChange,
          }}
          pagination={{
            options: [25, 50, 100],
            totalSize: totalSize,
            page: currentPage + 1,
            sizePerPage: currentSizePerPage,
            defaultOption: 25,
            showTotal: true,
            onPageChange: handlePageChange,
            onSizePerPageChange: handleSizePerPageChange,
          }}
        />
      )}
    </div>
  );
}
